import { PlaycastMessage, PlaycastRemoteMessages } from '@playcastdotio/Messaging';
import { ipcReceive, ipcSend } from './ipc';
import { rcReceive, rcSend } from './remoteControl';

export const getIpcMessagingInterface = () => {
  return {
    send: ipcSend,
    receive: ipcReceive,
  };
};

export const makeRemoteControlMessagingObject = (remoteDataConnection: any) => {
  return {
    send: (message: PlaycastMessage<PlaycastRemoteMessages>) => {
      rcSend(message, remoteDataConnection);
    },
    receive: (callback: (message: PlaycastMessage<PlaycastRemoteMessages>) => void) => {
      rcReceive(callback, remoteDataConnection);
    },
  };
};
